const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.card--product',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  syncWishlistButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    
    if (productCard) {
      productCard.setAttribute('data-product-handle', handle);
      return productCard.outerHTML;
    } else {
      console.error(`[Shopify Wishlist] Product card not found for handle: ${handle}`);
      return text;
    }
  })
  .catch((err) => {
    console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err);
    return `<div class="card card--product" data-error="true" data-product-handle="${handle}">Erro ao carregar produto</div>`;
  });
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

let wishlistClickBound = false;
let wishlistObserverStarted = false;

const syncWishlistButtons = () => {
  document.querySelectorAll(selectors.button).forEach((button) => {
    const productHandle = button.dataset.productHandle;
    if (!productHandle) return;
    button.classList.toggle(BUTTON_ACTIVE_CLASS, wishlistContains(productHandle));
  });
};

const handleWishlistClick = (event) => {
  const button = event.target.closest(selectors.button);
  if (!button) return;

  const productHandle = button.dataset.productHandle;
  if (!productHandle) {
    console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    return;
  }

  updateWishlist(productHandle);
};

const observeWishlistButtons = () => {
  if (wishlistObserverStarted) return;
  wishlistObserverStarted = true;

  const observer = new MutationObserver((mutations) => {
    const hasNewButton = mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        return node.matches(selectors.button) || node.querySelector(selectors.button);
      })
    );
    if (hasNewButton) syncWishlistButtons();
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

const bindWishlistClicks = () => {
  if (wishlistClickBound) return;
  wishlistClickBound = true;
  document.addEventListener('click', handleWishlistClick);
  observeWishlistButtons();
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  bindWishlistClicks();
  syncWishlistButtons();

  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};